import Default from "../Pages/Dashboard/Default/Default";
import CLothAssign from "../Pages/SamplePage/ClothAssign";
import AllClothAssign from "../Pages/Application/Master/book_ticket/AllClothAssign";
import AccountSettings from "../Pages/SamplePage/AccountSettings";
import AccountProfile from "../Pages/SamplePage/AccountProfile";
import ClothInvoice from "../Pages/Application/Master/book_ticket/ClothInvoice";


const clothCRoutes = [
  // dashboard
  { path: `${process.env.PUBLIC_URL}/dashboard/default`, Component: <Default /> },
 // Account
   { path: `${process.env.PUBLIC_URL}/account/account_settings`, Component: <AccountSettings /> },
   { path: `${process.env.PUBLIC_URL}/account/account_profile`, Component: <AccountProfile /> },
 
  { path: `${process.env.PUBLIC_URL}/cloth/cloth_assign`, Component: <CLothAssign /> },
   { path: `${process.env.PUBLIC_URL}/cloth/all_cloth_assign`, Component: <AllClothAssign/> },
   { path: `${process.env.PUBLIC_URL}/print-cloth-invoice/:id`, Component: <ClothInvoice /> },
];

export default clothCRoutes;
